import React, { useEffect, useRef } from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";
// eslint-disable-next-line import/no-extraneous-dependencies
import Lottie from "lottie-react";

import SuccessAnimationData from "../../../../../assets/images/common/animation/SuccessAnimation.json";
import "./ContactCsmSuccessModal.css";

export default function ContactCsmSuccessModal({ onDone }) {
  const lottieRef = useRef(null);

  const playSuccessAnimation = () => {
    if (lottieRef.current) {
      lottieRef.current.goToAndPlay(0, true);
    }
  };

  useEffect(() => {
    const timer = window.setTimeout(playSuccessAnimation, 200);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      afterOpenChange={(isOpen) => {
        if (isOpen) playSuccessAnimation();
      }}
      wrapClassName="ContactCsmSuccessModalWrap"
      className="ContactCsmSuccessModal"
      width={700}
    >
      <div className="ContactCsmSuccessModal__Content">
        <div className="ContactCsmSuccessModal__Gif" aria-hidden>
          <Lottie
            lottieRef={lottieRef}
            animationData={SuccessAnimationData}
            loop={false}
            autoplay={false}
          />
        </div>

        <p className="ContactCsmSuccessModal__Heading">
          We have received your request.
          <br />
          Our CSM team will reach out to you soon!
        </p>

        <Button
          type="primary"
          className="ContactCsmSuccessModal__Done"
          onClick={onDone}
        >
          Done
        </Button>
      </div>
    </Modal>
  );
}
